import '.ev{border-left:4px solid var(--gray-200);}.ssr-plugin'
import '.ew{padding-left:1.5rem;}.ssr-plugin'
import '.ex{margin:1rem 0;}.ssr-plugin'
import '.ey{color:var(--gray-700);}.ssr-plugin'
import '.ez{font-style:italic;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { PropsWithChildren } from 'react'

interface BlockQuoteProps extends PropsWithChildren {
  style?: Style
}

export const BlockQuote = ({ children, style }: BlockQuoteProps) => {
  return (
    <styled.blockquote className="ev ew ex ey ez"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.blockquote>
  )
}
